import {
    request
} from "./request";

// find all projects(GEO) meta info
export function getGeoMeta(projectid) {
    return request({
        url: '/ascancer/api/projects/geo',
        params: {
            projectid
        },
    })
}

// find all projects(TCGA) meta info
export function getTcgaMeta(projectid) {
    return request({
        url: '/ascancer/api/projects/tcga',
        params: {
            projectid
        },
    })
}

// find all projects(GTEx) meta info
export function getGtexMeta(projectid) {
    return request({
        url: '/ascancer/api/projects/gtex',
        params: {
            projectid
        },
    })
}